// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea {
  min-height: 200px;
}

.search-container {
  margin-bottom: 10px;
}

.variables-list {
  width: 300px;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #ccc;
  padding: 10px;
}

.variables-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Create 3 equal columns */
  gap: 10px; /* Adjust the gap between items */
}

.variable-item {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
  background-color: #f9f9f9;
  cursor: pointer;
}

@media (max-width: 768px) {
  .variables-grid {
    grid-template-columns: repeat(2, 1fr); /* Switch to 2 columns on smaller screens */
  }
}
@media (max-width: 480px) {
  .variables-grid {
    grid-template-columns: 1fr; /* Switch to 1 column on very small screens */
  }
}
.bar-section .row {
  margin: 0; /* Remove default row margin */
}

.bar-section .tab-column {
  background-color: #262626; /* Default background color */
  color: white; /* Default text color */
  text-align: left;
  padding: 15px 20px;
  font-size: 20px;
  border: 1px solid rgb(204, 202, 202);
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

.btn-submit {
  background-color: #0060d6;
  color: white;
  transition: background 0.3s ease-in-out;
}
.btn-submit:hover {
  background-color: #1a1a86;
}

.btn-var {
  background-color: #417bc2;
  color: white;
  transition: background 0.3s ease-in-out;
}
.btn-var:hover {
  background-color: #2d2db4;
}

.btn-var-2 {
  color: #417bc2;
  background: transparent;
  border-color: #417bc2;
  transition: background 0.3s ease-in-out;
}
.btn-var-2:hover {
  color: white;
  background-color: #2d2db4;
}`, "",{"version":3,"sources":["webpack://./src/app/features/ada-access/rules/rules-create/rules-create/rules-create-or-update.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,qCAAA,EAAA,2BAAA;EACA,SAAA,EAAA,iCAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AACF;;AAEA;EACE;IACE,qCAAA,EAGG,2CAAA;EAFL;AACF;AAKA;EACE;IACE,0BAAA,EAAA,6CAAA;EAHF;AACF;AAMA;EACE,SAAA,EAAA,8BAAA;AAJF;;AAOA;EACE,yBAAA,EAAA,6BAAA;EACA,YAAA,EAAA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,sCAAA;AAJF;;AAOA;EACE,yBAAA;EACA,YAAA;EACA,uCAAA;AAJF;AAME;EACE,yBAAA;AAJJ;;AAUA;EACE,yBAAA;EACA,YAAA;EACA,uCAAA;AAPF;AASE;EACE,yBAAA;AAPJ;;AAYA;EACE,cAAA;EACE,uBAAA;EACF,qBAAA;EACA,uCAAA;AATF;AAWG;EACC,YAAA;EACA,yBAAA;AATJ","sourcesContent":["textarea {\n  min-height: 200px;\n}\n\n.search-container {\n  margin-bottom: 10px;\n}\n\n.variables-list {\n  width: 300px;\n  max-height: 400px;\n  overflow-y: auto;\n  overflow-x: auto;\n  border: 1px solid #ccc;\n  padding: 10px;\n}\n\n.variables-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr); /* Create 3 equal columns */\n  gap: 10px; /* Adjust the gap between items */\n}\n\n.variable-item {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  text-align: center;\n  background-color: #f9f9f9;\n  cursor: pointer;\n}\n\n@media (max-width: 768px) {\n  .variables-grid {\n    grid-template-columns: repeat(\n      2,\n      1fr\n    ); /* Switch to 2 columns on smaller screens */\n  }\n}\n\n@media (max-width: 480px) {\n  .variables-grid {\n    grid-template-columns: 1fr; /* Switch to 1 column on very small screens */\n  }\n}\n\n.bar-section .row {\n  margin: 0; /* Remove default row margin */\n}\n\n.bar-section .tab-column {\n  background-color: #262626; /* Default background color */\n  color: white; /* Default text color */\n  text-align: left;\n  padding: 15px 20px;\n  font-size: 20px;\n  border: 1px solid rgb(204, 202, 202);\n  border-radius: 5px;\n  transition: background-color 0.3s ease;\n}\n\n.btn-submit {\n  background-color: #0060d6;\n  color: #ffff;\n  transition: background 0.3s ease-in-out;\n\n  &:hover{\n    background-color: #1a1a86;\n  }\n}\n\n\n\n.btn-var {\n  background-color: #417bc2;\n  color: #ffff;\n  transition: background 0.3s ease-in-out;\n\n  &:hover{\n    background-color: #2d2db4;\n  }\n}\n\n\n.btn-var-2 {\n  color: #417bc2;\n    background: transparent;\n  border-color: #417bc2;\n  transition: background 0.3s ease-in-out;\n\n   &:hover{\n    color: white;\n    background-color: #2d2db4;\n\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
